"use strict";
'use es6'; // used to dispatch error actions and then re-throw to bubble up Error

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchAndThrowError = void 0;

var dispatchAndThrowError = function dispatchAndThrowError(_ref) {
  var dispatch = _ref.dispatch,
      type = _ref.type,
      error = _ref.error;
  dispatch({
    type: type,
    payload: {
      error: error
    }
  });
  throw error;
};

exports.dispatchAndThrowError = dispatchAndThrowError;